import Highcharts from 'highcharts';

function createLockedSeries(options: Highcharts.SeriesLineOptions): Highcharts.SeriesOptions {
  return {
    ...options,
    // @ts-ignore
    tooltip: {
      headerFormat: '',
      ...options.tooltip
    },
    marker: {
      enabled: false,
      states: {
        hover: {
          enabled: false
        }
      }
    }
  };
}

export default createLockedSeries;
